export enum UserRole {
  admin = "admin",
  member = "member",
  chatManager = "chat_manager",
  chatEmployee = "chat_employee",
  taskManager = "task_manager",
  taskEmployee = "employee",
  travelLogEmployee = "travel_log_employee",
}
